import moment from 'moment';

export type DateMoment = Date | moment.Moment;

export enum TimeScale {
    LIVE = 'live',
    HOURLY = 'hau',
    DAILY = 'dau',
    WEEKLY = 'wau',
    MONTHLY = 'mau'
}

export enum TimeRange {
    WEEK = 'week',
    FORTNIGHT = 'fortnight',
    MONTH = 'month',
    THREE_MONTHS = 'threeMonths',
    TIME_RANGE = 'timeRange'
}

export interface DateRange {
    startDate?: DateMoment;
    endDate?: DateMoment;
    selectedDate?: DateMoment;
}

export enum PreviousPeriod {
    TWO_WEEKS = 'twoWeeks',
    FOUR_WEEKS = 'fourWeeks'
}

export enum TrendLine {
    RECOMMENDED = 'recommended',
    UNACCCEPTABLE = 'unacceptable'
}
